export enum MessageList {
    successChange = "profile-change-success",
    failChange = "profile-change-fail",
    failProfileImg = "profile-image-upload-fail",
    shareURL = "common-link-copy",
    public = "profile-public-change-success",
    private = "profile-private-change-success"
}

export default MessageList;